<div
  class="datatable-filters"
  [class.right]="position() === 'right'"
  [class.headless]="headless()"
  [style.width.px]="headless() ? null : width()"
>
  @if (!headless()) {
    <vectronic-card
      [title]="'Filter'"
      [displayClose]="true"
      (closed)="closeEvent.emit()"
      [closeIcon]="position() === 'left' ? 'chevron_left' : 'chevron_right'"
    >
      <ng-template #cardButtons>
        @if (showSavedFiltersButton()) {
          <div
            [matTooltip]="
              isDefaultFilter()
                ? 'Default Filter'
                : selectedSavedFilterValue()
                  ? 'Edit Filter'
                  : 'Save Filter'
            "
          >
            <button
              mat-icon-button
              [matMenuTriggerFor]="savedFiltersMenu"
              #savedFiltersMenuTrigger="matMenuTrigger"
              (menuOpened)="setSavedFiltersMenuTrigger(savedFiltersMenuTrigger)"
              [disabled]="isDefaultFilter()"
            >
              <mat-icon [class.filled-star]="selectedSavedFilterValue()">{{
                selectedSavedFilterValue() ? 'star' : 'star_outline'
              }}</mat-icon>
            </button>
          </div>
        }
      </ng-template>

      <div body class="filters-container">
        <ng-container *ngTemplateOutlet="savedFiltersControls"></ng-container>

        <ng-container *ngTemplateOutlet="filtersItems"></ng-container>
      </div>
      <mat-card-footer class="apply-buttons" [hidden]="!hasApplyButton()">
        @if (hasApplyButton()) {
          <button mat-button color="accent" class="w-100" (click)="onApply()">
            <mat-icon>check_circle</mat-icon>
            Apply
          </button>
          <button mat-button color="warn" class="w-100" (click)="onReset()">
            <mat-icon>cancel</mat-icon>
            Reset
          </button>
        }
      </mat-card-footer>
    </vectronic-card>
  } @else {
    <div class="filters-container">
      <ng-container *ngTemplateOutlet="savedFiltersControls"></ng-container>
      <ng-container *ngTemplateOutlet="filtersItems"></ng-container>
    </div>
  }
</div>

<mat-menu #savedFiltersMenu="matMenu" class="saved-filters-menu">
  <div class="saved-filters-menu__content" (click)="$event.stopPropagation()">
    <div class="saved-filters-menu__header">
      <div class="saved-filters-menu__title">
        {{ selectedSavedFilterValue() ? 'Edit Filter' : 'Create New' }}
      </div>
      <button mat-icon-button type="button" (click)="closeSavedFiltersPanel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-form-field appearance="outline" class="saved-filters-menu__field">
      <mat-label>Filter name</mat-label>
      <input
        matInput
        #filterNameInput
        [value]="savedFilterName()"
        [disabled]="isDefaultFilter()"
        (input)="onSavedFilterNameInput($event)"
        (keydown.enter)="onSavedFilterNameEnter()"
        placeholder="Enter filter name"
      />
    </mat-form-field>
    <mat-checkbox
      class="saved-filters-menu__checkbox mb-16 mt--12"
      [checked]="showOnDashboard()"
      [disabled]="isDefaultFilter()"
      (change)="onShowDashboardToggle($event.checked)"
    >
      Show on dashboard
    </mat-checkbox>
    <div class="saved-filters-menu__actions">
      @if (canDeleteSelectionFilter()) {
        <button mat-stroked-button color="warn" (click)="onDeleteSelectionFilter()">Delete</button>
      }
      @if (!isDefaultFilter()) {
        <button
          mat-flat-button
          color="primary"
          [disabled]="!canSubmitSelectionFilter() || isDuplicateSelectionFilterName()"
          (click)="onDoneSelectionFilter()"
        >
          Save
        </button>
      }
    </div>
  </div>
</mat-menu>

<ng-template #savedFiltersControls>
  @if (showSavedFiltersButton()) {
    <div class="saved-filters-controls" [class.saved-filters-controls--headless]="headless()">
      <table-datatable-saved-filter-select
        [filters]="selectionFilters()"
        [value]="selectedSavedFilterValue()"
        (valueChange)="onSelectionFilterSelected($event)"
      ></table-datatable-saved-filter-select>
      @if (mobileService.isOn()) {
        <div
          [matTooltip]="
            isDefaultFilter()
              ? 'Default Filter'
              : selectedSavedFilterValue()
                ? 'Edit Filter'
                : 'Save Filter'
          "
        >
          <button
            mat-icon-button
            [matMenuTriggerFor]="savedFiltersMenu"
            #savedFiltersMenuTrigger="matMenuTrigger"
            (menuOpened)="setSavedFiltersMenuTrigger(savedFiltersMenuTrigger)"
            [disabled]="isDefaultFilter()"
            type="button"
          >
            <mat-icon [class.filled-star]="selectedSavedFilterValue()">
              {{ selectedSavedFilterValue() ? 'star' : 'star_outline' }}
            </mat-icon>
          </button>
        </div>
      }
    </div>
    <div class="saved-filters-divider"></div>
  }
</ng-template>

<ng-template #filtersItems>
  @for (filter of filters(); track filter.title) {
    <div class="filter-item" [class.filter-item--disabled]="filter.disabled">
      @if (filter.type === 'input') {
        <table-datatable-filter-input
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [options]="filter.options"
          [placeholder]="filter.placeholder ?? ''"
          [tooltip]="filter.tooltip ?? ''"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-input>
      } @else if (filter.type === 'process-id') {
        <table-datatable-filter-process-id
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          [disabled]="filter.disabled"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-process-id>
      } @else if (filter.type === 'multi-select') {
        <table-datatable-filter-multi-select
          [title]="filter.title"
          [options]="filter.options"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          [disabled]="filter.disabled"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-multi-select>
      } @else if (filter.type === 'single-select') {
        <table-datatable-filter-single-select
          [title]="filter.title"
          [options]="filter.options"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-single-select>
      } @else if (filter.type === 'boolean') {
        <table-datatable-filter-boolean
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-boolean>
      } @else if (filter.type === 'date') {
        <table-datatable-filter-date
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-date>
      } @else if (filter.type === 'single-date') {
        <table-datatable-filter-single-date
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [options]="filter.options"
          [expanded]="isExpanded(filter.title)"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-single-date>
      } @else if (filter.type === 'integer') {
        <table-datatable-filter-integer
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          [options]="filter.options"
          [hideToggle]="filter.hideToggle"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-integer>
      } @else if (filter.type === 'minMax') {
        <table-datatable-filter-min-max
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          [options]="filter.options"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-min-max>
      } @else if (filter.type === 'time') {
        <table-datatable-filter-time
          [title]="filter.title"
          [value]="getFilterValue(filter.title)"
          [expanded]="isExpanded(filter.title)"
          [options]="filter.options"
          (toggled)="toggleFilter(filter.title)"
          (valueChange)="emitChange(filter.title, $event)"
        ></table-datatable-filter-time>
      }
    </div>
  }
</ng-template>
